import { authenticatedFetch } from "./http";

export interface TranslationOverride {
  key: string;
  language: string;
  value: string;
  updatedAt: string;
  version: number;
}

export interface TranslationTransferFile {
  schemaVersion: number;
  exportedAt: string;
  entries: Array<{ key: string; language: string; value: string }>;
}

export interface TranslationImportResult {
  imported: number;
  unchanged: number;
}

export const loadTranslationOverrides = () =>
  authenticatedFetch<TranslationOverride[]>("/api/v1/configuration/translations");

export const saveTranslationOverride = (language: string, key: string, value: string) =>
  authenticatedFetch<TranslationOverride>(
    `/api/v1/configuration/translations/${encodeURIComponent(language)}`,
    { method: "PUT", body: JSON.stringify({ key, value }) }
  );

export const exportTranslationOverrides = () =>
  authenticatedFetch<TranslationTransferFile>("/api/v1/configuration/translations/export");

export const importTranslationOverrides = (transfer: TranslationTransferFile) =>
  authenticatedFetch<TranslationImportResult>("/api/v1/configuration/translations/import", {
    method: "POST",
    body: JSON.stringify(transfer),
  });
